import React from "react";
// react component that copies the given text inside your clipboard
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  Button,
} from "reactstrap";
import {
  Link
} from "react-router-dom";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import Select from "react-select";
import { toast } from 'react-toastify';
import ProvisionerService from '../../services/api/Provisioner'
import PlatformProvisionerService from '../../services/api/PlatformProvisioner';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Switch from "react-bootstrap-switch";
import { isJSON, convertTextToTitleCase } from "settings/shared/commonMethod";
import { provisionerTypeLogo } from "settings/shared/commonMethod";
import { FilePond } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import { Scrollbars } from 'react-custom-scrollbars';


const styles = {
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
  passwordHint: {
    color: "#000",
    fontSize: 12
  }
}

class NewProvisioner extends React.Component {

  constructor(props) {
    super(props)     
    this.state = { 
    errorSubmitted:false,
    name:"",
    serviceAccount:"",
    services:[],
    provisionerType:"",
    provisionerType_change:"",
    btnActions:"Create Provisioner",
    editId:"",
    accessKey:"",
    secretKey:"",
    description:"",
    enableProvisionerAccess:true,
    defaultServices:[],
    serviceaccountfiles:[],
    swidth: window.innerWidth,
    sheight: window.innerHeight,
    provisionerTypes : [],
    provisionerServiceList : []
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);


  }
  /* To get Input Text */
  handleChange = (event) => {
    event.preventDefault();
    console.log((event.target))
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleTypeChange = (e) => {
    this.setState({ provisionerType: e.target.value })
  }

  handleChangeService = (event) => {
    if (event !== null) {
      let newService = [];
      for (var i = 0; i < event.length; i++) {
        newService.push(event[i].value)
      }
      this.setState({
        services: newService
      })
    } else {
      this.setState({
        services: []
      })
    }

  }

  handleChangeTypes = (event) => {
    this.setState({
      provisionerType: event.value
    }, () => {
      this.getServiceListByProvisionerType(this.state.provisionerType);
    })
  }
  
cancelClick = () =>{
  this.props.history.push('/cloud/Provisioner/');    
}
handleSwitch(elem, state) {
  // let proState = state==true?"ENABLED":"DISABLED";
  this.setState({enableProvisionerAccess:state})
}

  componentDidMount() {
    let mode = this.props.location.state.mode;
    if (mode === "editProvisioner") {
      Promise.all([this.getServiceListByProvisionerType(this.props.location.state.type)]).then(values => {
        this.GetEditProvisioner(this.props.location.state.editId)
      })
    }
    else {
      this.setState({
        btnActions: "Create",
      }, () => {
        this.getProvisionerTypes();
      });
    }
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  setErrorMessage(message){
    if(message === ""){
      this.setState({
        errorMessage: message,
        errorSubmitted: false
      })
    } else {
      document.getElementById('errorDiv').scrollIntoView()
      this.setState({
        errorMessage: message,
        errorSubmitted: true
      });
    }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
  }

  getProvisionerTypes = () => {
    ProvisionerService.getProvisionerTypes()
      .then((response) => {
        let tempTypes = [];
        let types = response.provisionerTypes;
        if (types !== null && types.length > 0) {
          for (let type of types) {
            tempTypes.push({
              label: <div><img className="" src={provisionerTypeLogo(type)} alt="logo" />&nbsp; {type}</div>,
              value: type,
            })
          }
          this.setState({
            provisionerTypes: tempTypes
          })
        }
      }
      );
  }

  getServiceListByProvisionerType = (type) => {
    ProvisionerService.getserviceByProvisionerType(type)
      .then((response) => {
        let tempSerives = [];
        let services = response.serviceTypes;
        if (services !== null && services.length > 0) {
          for (let service of services) {
            tempSerives.push({
              label: convertTextToTitleCase(service.replace("_", " ")),
              value: service,
            })
          }
          this.setState({
            provisionerServiceList: tempSerives
          })
        }
      }
      );
  }

  filterServiceFromBase = (services) => {
    let filterService = []; // for auto select default values
    if (services.length !== 0) {
        for (let service of services) {
          let selectService = this.state.provisionerServiceList.filter(item => item.value === service)
          filterService.push(selectService[0]);
        }
      return filterService;
    }
  }

// Edit Connecotors
GetEditProvisioner(id) {
  this.setState({
    loading: true,
    btnActions: "Update",
    editId: id,
    });
    if (localStorage.getItem("role") === "PLATFORM_ADMIN") {
      PlatformProvisionerService.getAllPlatformProvisioner()
    .then((response) => {
      if (response.status === 'SUCCESS' && response.provisionerDTOS !== undefined && response.provisionerDTOS.length > 0) {
        let provisionerData = response.provisionerDTOS[0];
          this.setState({
            name:provisionerData.name,
            description:provisionerData.description,
            enableProvisionerAccess:provisionerData.provisionerStatus === "ENABLED" ? true : false,  
            provisionerType:provisionerData.provisionerType,
            provisionerType_change:provisionerData.provisionerType,
            services:provisionerData.services,
            defaultServices:this.filterServiceFromBase(provisionerData.services),
            loading:false
          })
      }else {
        this.setState({ loading: false}); 
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    }).catch((error) => {
      this.setState({ loading:false });
    })
    }
    else{
  ProvisionerService.getProvisionerById(id)
    .then((response) => {
        if (response.status === 'SUCCESS' && response.provisionerDTOS !== undefined && response.provisionerDTOS.length > 0) {
        let provisionerData = response.provisionerDTOS[0];
          this.setState({
            name:provisionerData.name,
            description:provisionerData.description,
            enableProvisionerAccess:provisionerData.provisionerStatus === "ENABLED" ? true : false,  
            provisionerType:provisionerData.provisionerType,
            provisionerType_change:provisionerData.provisionerType,
            services:provisionerData.services,
            defaultServices:this.filterServiceFromBase(provisionerData.services),
            loading:false
          })
      } else {
        this.setState({ loading:false });
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    }).catch((error) => {
      this.setState({ loading:false });
    })
  // }
  }

  }

  PostProvisioner = () => {
    this.setErrorMessage("");
    if (!this.state.errorSubmitted) {
      let provisionerData = ""
      if (this.state.provisionerType === "AWS") {
        provisionerData = {
          accessKeyId: this.state.accessKey,
          secretAccessKey: this.state.secretKey,
        }
      }
      if (this.state.provisionerType === "GOOGLE") {
        provisionerData = {
          serviceAccount: this.state.serviceAccount,
        }
      }

      if (this.state.provisionerType === "AZURE") {
        provisionerData = {
          accountName: this.state.azureaccountName,
          accountAccessKey: this.state.azureaccessKeyId
        }
      }
      let post = {}

      if (localStorage.getItem("role") === "PLATFORM_ADMIN") {
        post = {
          accountId: localStorage.getItem("accountId"),
          active: true,
          provisionerConfig: provisionerData,
          name: this.state.name,
          description: this.state.description,
          provisionerType: this.state.provisionerType,
          provisionerStatus: this.state.enableProvisionerAccess === true ? "ENABLED" : "DISABLED",
          services: this.state.services

        }
      }
      else {
        post = {
          accountId: localStorage.getItem("accountId"),
          active: true,
          id: this.state.editId,
          provisionerConfig: provisionerData,
          name: this.state.name,
          description: this.state.description,
          provisionerType: this.state.provisionerType,
          provisionerStatus: this.state.enableProvisionerAccess === true ? "ENABLED" : "DISABLED",
          services: this.state.services

        }
      }

      if (localStorage.getItem("role") === "PLATFORM_ADMIN") {
        PlatformProvisionerService.PostPlatformProvisioner(post)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Provisioner Created Successfully!</b></i>);
              this.props.history.push('/cloud/Provisioner/');
              this.clearformData();   // Reset Form data    
            } else {
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
              // this.setErrorMessage("Error in Creating Connector");
            }
          }
          );
      }
      else {
        ProvisionerService.PostProvisioner(post)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Provisioner Created Successfully!</b></i>);
              this.props.history.push('/cloud/Provisioner/');
              this.clearformData();   // Reset Form data    
            } else {
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
              // this.setErrorMessage("Error in Creating Connector");
            }
          }
          );
      }

    } else {
      console.error('Invalid Form')
    }
  }


  updateProvisoner = () => {
    this.setErrorMessage("");
    if (!this.state.errorSubmitted) {
      let post = {}
      if (localStorage.getItem("role") === "PLATFORM_ADMIN") {
        post = {
          accountId: localStorage.getItem("accountId"),
          active: true,
          name: this.state.name,
          description: this.state.description,
          provisionerType: this.state.provisionerType,
          provisionerStatus: this.state.enableProvisionerAccess === true ? "ENABLED" : "DISABLED",
          services: this.state.services
        }
        PlatformProvisionerService.UpdatePlatformProvisioner(post, this.state.editId)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Provisioner Updated Successfully!</b></i>);
              this.props.history.push('/cloud/Provisioner/');
              this.clearformData();   // Reset Form data    
            } else {
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
              // this.setErrorMessage("Error in Creating Connector");
            }
          }
          );
      }
      else {
        post = {
          accountId: localStorage.getItem("accountId"),
          active: true,
          id: this.state.editId,
          name: this.state.name,
          description: this.state.description,
          provisionerType: this.state.provisionerType,
          provisionerStatus: this.state.enableProvisionerAccess === true ? "ENABLED" : "DISABLED",
          services: this.state.services
        }
        ProvisionerService.UpdateProvisioner(post, this.state.editId)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Provisioner Updated Successfully!</b></i>);
              this.props.history.push('/cloud/Provisioner/');
              this.clearformData();   // Reset Form data    
            } else {
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
              // this.setErrorMessage("Error in Creating Connector");
            }
          }
          );
      }
    } else {
      console.error('Invalid Form')
    }
  }


  // Submit New Connection Data
  CreateNewProvisioner = (event) => {
    event.preventDefault();
    if((this.state.name === "" || this.state.name === undefined)){
      this.setErrorMessage("Please Enter Name");
    } 
    else if(this.state.provisionerType === ""){
      this.setErrorMessage("Please Select Provisioner Type");
    }else{
      if(this.state.provisionerType === "AWS"){
        if(this.state.accessKey === "" && this.state.editId === ""){
            this.setErrorMessage("Please Enter Access Key");
          } else if(this.state.secretKey === "" && this.state.editId === ""){
          this.setErrorMessage("Please Enter Secret Key");
        }
        else if (this.state.services.length === 0) {
          this.setErrorMessage("Please Select atleast one service");
        } else {
          if (this.state.editId !== "") {
            this.updateProvisoner();
          } else {
            this.PostProvisioner();
          }
        }
      }
      if (this.state.provisionerType === "GOOGLE") {
        if ((this.state.serviceAccount === "" && this.state.editId === "")) {
          this.setErrorMessage("Please Enter Service Account");
        }
        else if (!isJSON(this.state.serviceAccount) && this.state.editId === "") {
          this.setErrorMessage("Please Enter Valid Service Account");
        }
        else if (this.state.services.length === 0) {
          this.setErrorMessage("Please Select atleast one service");
        }
        else {
          if (this.state.editId !== "") {
            this.updateProvisoner();
          } else {
            this.PostProvisioner();
          }
        }
      }

      if (this.state.provisionerType === "AZURE") {
        if ((this.state.azureaccountName === "" && this.state.editId === "")) {
          this.setErrorMessage("Please Enter the Account Name");
        }
        else if (this.state.azureaccessKeyId === "" && this.state.editId === "") {
          this.setErrorMessage("Please Enter Access Key");
        }
        else if (this.state.services.length === 0) {
          this.setErrorMessage("Please Select atleast one service");
        }
        else {
          if (this.state.editId !== "") {
            this.updateProvisoner();
          } else {
            this.PostProvisioner();
          }
        }
      }

    }
  }


  // Reset form data
  clearformData() {
    this.setState({
      name: "",
      provisionerType: "AWS",
      server: '',
      warehouse: '',
      user: '',
      enableProvisionerAccess: true,
      password: '',
      editId: "",
      database: "",
      port: "",
      host: "",
      provisionerType_change: ""
    })
  }



  render() {
    return (

      <>
        <PanelHeader
          content={
            <div className="header text-center">

            </div>
          }
        />
        <div className="content">
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
            <Col xs={12} md={12}>
              <Row>
                <div className=" col" id="errorDiv">
                  <Card className=" shadow">
                    <CardHeader className=" bg-transparent">
                      <Row className="align-items-center">
                        <div className="col">
                          {this.state.editId !== "" && <h5 className="mb-0">Update Provisioner</h5>}
                          {this.state.editId === "" && <h5 className="mb-0">Create  Provisioner</h5>}
                        </div>
                        <div className="col text-right">
                          <Link to="/cloud/Provisioner/" >
                            <span className="close clear-filter">×</span>
                          </Link>
                        </div>
                      </Row>
                    </CardHeader>
                    <CardBody>

                      <div className="carcontent">
                        <Scrollbars autoHeight autoHeightMin={this.state.sheight - 220}>

                          {this.state.errorSubmitted &&
                            <div style={styles.errorBox}>
                              <span style={styles.error}>{this.state.errorMessage}</span>
                            </div>
                          }
                          {/* <code><b>Provisioner Basic Details</b></code>
                    <br></br> */}
                          {/* <Card className="card-contributions">
                    <CardBody> */}
                    <Row xs="12" style={{paddingRight:10}}>
                    <Col lg="6">
                    <code><b>Provisioner Basic Details</b></code>
                    <br />
                    <Card className="card-contributions" style={{marginTop: 10}}>
                    <CardBody>
                    <Row className="icon-examples" style={{marginTop:10,marginRight:0}}>
                        <Col lg="12"> 
                        <Label md="12">Name *</Label>
                        <FormGroup>
                        <Input
                          className="form-control"
                          placeholder="Name"
                          name="name"
                          value={this.state.name}
                          type="text"
                          onChange={this.handleChange}/>
                        </FormGroup>
                        </Col>
                    </Row>

                    <Row className="icon-examples" style={{marginTop:10,marginRight:0}}>  
                        <Col lg="12">
                      <Label md="12">Description</Label>
                        <FormGroup>
                        <Input
                            className="form-control descrip"
                            placeholder="Description"
                            name="description"
                            value={this.state.description}
                            type="textarea"
                            onChange={this.handleChange} noValidate />
                        </FormGroup>
                        </Col>  
                    </Row>

                    <Row className="icon-examples" style={{marginTop:10}}>  
                    {this.state.editId === "" && <Col lg="12">
                      <Label md="12">Provisioner Type *</Label>
                        <FormGroup>
                        <Select className="selectMargin"
                            values={this.state.provisionerTypes.filter(item => item.value === this.state.provisionerType)}
                            options={this.state.provisionerTypes} onChange={this.handleChangeTypes} />
                            </FormGroup>
                        </Col>  }

                      {this.state.editId !== "" && <Col lg="8">
                      <Row>
                        <Col>
                        <Label>Provisioner Type :</Label>                        
                        <img src={provisionerTypeLogo(this.state.provisionerType)} alt="logo" />  {this.state.provisionerType}
                        </Col>
                      </Row>
                        </Col>}
                    </Row>
                    </CardBody>
                    </Card>
                  </Col>

                  <Col lg="6">
                  {this.state.provisionerType !== "" && <code><b>Provisioner Config Details</b></code>}
                    <br />
                    {this.state.provisionerType !== "" &&<Card className="card-contributions" style={{marginTop: 10}}><CardBody>
                 {this.state.provisionerType === "GOOGLE" &&

            this.state.editId === "" && <div>
              <Row>
                <Col lg="12">
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="input-email"
                    >
                     Service Account File(JSON)
                    </label>
                    <Input
                                        className="form-control-alternative"
                                        placeholder="Put your data right here or select a file"
                                        // disabled
                                        rows="4"
                                        style={styles.rowAlign}
                                        id="textAreaserviceacct"
                                        value={this.state.serviceAccount}
                                        type="textarea"
                                        name="serviceAccount"
                                        onChange={this.handleChange} noValidate
                                      />
                   </FormGroup>
                </Col>                       
              </Row>   
              <Row>
                <Col lg="12">
                    <FilePond
                       files={this.state.serviceaccountfiles}
                       allowMultiple={false}
                       maxFiles={1}
                       allowFileTypeValidation= {true}  
                       acceptedFileTypes={['text/*','application/json']}
                       labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
                                        server={{
                                          process: (fieldName, file, metadata, load) => {
                                            setTimeout(() => {
                                              load(Date.now());
                                            }, 1500);
                                          },
                                          load: (source, load) => {
                                            fetch(source)
                                              .then(res => {
                                                //console.log(res);
                                                return res.blob();
                                              })
                                              .then(blob => {
                                                //console.log(blob);
                                                return load(blob);
                                              });
                                          }
                                        }}
                                        onupdatefiles={fileItems => {
                                          this.setState({
                                            serviceaccountfiles: fileItems.map(fileItem => fileItem.file)
                                          });
                                          //console.log(this.state.files[0])
                                          if (this.state.serviceaccountfiles.length > 0) {
                                            var fr = new FileReader();
                                            fr.readAsText(this.state.serviceaccountfiles[0]);
                                            fr.onload = function (event) {
                                              document.getElementById("textAreaserviceacct").value = event.target.result;
                                            }
                                          } else {
                                            document.getElementById("textAreaserviceacct").value = "";
                                          }
                                        }}
                                      />
                </Col>
                </Row>  
                </div>       
                 }
                 {this.state.provisionerType === "AWS" &&
                      <Row className="mt-12">
              <Col className="mb-12 mb-xl-0" xl="12">
                    {this.state.editId === "" && <Row className="icon-examples">
                        <Col lg="12"> 
                        <Label md="12">Access Key *</Label>
                        <FormGroup> <Input
                          className="form-control"
                          placeholder="Access Key"
                          name="accessKey"
                          value={this.state.accessKey}
                          type="text"
                          onChange={this.handleChange}/>
                          </FormGroup>
                        </Col>  
                        </Row>}
                        {this.state.editId === "" && <Row>
                        <Col lg="12">
                      <Label md="12">Secret Key *</Label>
                      <FormGroup>
                            <Input
                          className="form-control"
                          placeholder="Secret Key"
                          name="secretKey"
                          value={this.state.secretKey}
                          type="text"
                          onChange={this.handleChange}/>
                          </FormGroup>
                        </Col>
                       
                    </Row>}
                  </Col>
            </Row>

                }

                                {this.state.provisionerType === "AZURE" &&
                                  <Row className="mt-12">
                                    <Col className="mb-12 mb-xl-0" xl="12">
                                      {this.state.editId === "" && <Row className="icon-examples">
                                        <Col lg="12">
                                          <Label md="12">Account Name *</Label>
                                          <FormGroup> <Input
                                            className="form-control"
                                            placeholder="Account Name"
                                            name="azureaccountName"
                                            value={this.state.azureaccountName}
                                            type="text"
                                            onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>
                                      </Row>}
                                      {this.state.editId === "" && <Row>
                                        <Col lg="12">
                                          <Label md="12">Access Key *</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Access Key"
                                              name="azureaccessKeyId"
                                              value={this.state.azureaccessKeyId}
                                              type="text"
                                              onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>

                                      </Row>}
                                    </Col>
                                  </Row>

                                }


               {this.state.provisionerType !== "" && <Row className="mt-12">
              <Col className="mb-12 mb-xl-0" xl="12">
                    <Row className="icon-examples">
                        <Col lg="12"> 
                        <Label md="12">Services *</Label>
                        <FormGroup>
                      <Select className="selectMargin"
                          closeMenuOnSelect={false}
                          isMulti
                          defaultValue={this.state.defaultServices}
                          values={this.state.provisionerServiceList.filter(item => item.value === this.state.services)}
                          options={this.state.provisionerServiceList} onChange={this.handleChangeService} />
                          </FormGroup>
                        </Col>  
                        </Row>
                  </Col>
            </Row>}
            </CardBody>
            </Card>}
                  </Col>
                  
            </Row>

                    {this.state.editId !== "" && <Row>
                      <Col md="6">
                      <FormGroup style={{marginLeft:14}}>
                          {/* <Switch defaultValue={false}/> <Switch /> */}
                          <Label>Enable Provisioner </Label>&nbsp; &nbsp;&nbsp; &nbsp;<Switch onChange={(el, state) => this.handleSwitch(el, state)} value={this.state.enableProvisionerAccess} name='write access' data-on-color="secondary" data-off-color="default"/>

                          </FormGroup>
                          </Col>
                    
                      </Row>}
                    {/* </CardBody>
                </Card> */}


                          <hr className="my-4" />

                          <Row className="stickybuttons">
                            <Col lg="1">
                              <FormGroup>
                                <Button
                                  color="secondary"
                                  size="sm"
                                  type="submit"
                                  onClick={this.cancelClick}
                                >
                                  Cancel
                                </Button>
                              </FormGroup>
                            </Col>
                            <Col lg="2">
                              <FormGroup>
                                <Button
                                  color="primary"
                                  size="sm"
                                  type="submit"
                                  onClick={this.CreateNewProvisioner}
                                >
                                  {this.state.btnActions}
                                </Button>
                              </FormGroup>
                            </Col>
                          </Row>
                        </Scrollbars>

                      </div>
                    </CardBody>
                  </Card>
                </div>
              </Row>
            </Col>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default NewProvisioner;
